import { Formik, FormikHelpers } from "formik";
import { FC } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaFilter } from "react-icons/fa";
import yup from "app/util/yup";
import { StatusAlert } from "app/component/form/StatusAlert";
import { FormControlSelectReportVersionStatus } from "app/component/form/control/FormControlSelectReportVersionStatus";
import { ReportVersionStatus } from "app/api/graph/types";

type Props = {
    initialValues: FormValues;
    onSubmit: (values: FormValues) => void;
};

export type FormValues = {
    title?: string;
    status?: ReportVersionStatus;
};

const schema: yup.ObjectSchema<FormValues> = yup.object({
    title: yup.string(),
    status: yup.mixed<ReportVersionStatus>().oneOf(Object.values(ReportVersionStatus)),
});

export const ReportsTableFiltersForm: FC<Props> = (props) => {
    const onSubmit = (values: FormValues, actions: FormikHelpers<FormValues>) => {
        props.onSubmit(values);
        actions.setSubmitting(false);
    };

    return (
        <Formik validationSchema={schema} onSubmit={onSubmit} initialValues={props.initialValues}>
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                isSubmitting,
                errors,
                touched,
                status,
                setFieldValue,
                setFieldTouched,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StatusAlert status={status as unknown} />
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="search"
                            name="title"
                            value={values.title ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.title && !!errors.title}
                        />
                        <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <FormControlSelectReportVersionStatus
                            name="status"
                            value={values.status}
                            onChange={(value) => setFieldValue("status", value)}
                            onBlur={() => setFieldTouched("status")}
                            isInvalid={touched.status && !!errors.status}
                        />
                        <Form.Control.Feedback type="invalid">{errors.status}</Form.Control.Feedback>
                    </Form.Group>
                    <Button type="submit" disabled={isSubmitting}>
                        <FaFilter /> Filter
                    </Button>
                </Form>
            )}
        </Formik>
    );
};
